import { setBusy, setToastMessage } from '../components/app/actions'

// Common API function interceptor
export const api = (path, options, dispatch) => {
    dispatch(setBusy({ busy: true }))
    return fetch(path, {
        ...options,
        method: options.method,
        credentials: 'same-origin',
        headers: new Headers({
            'Content-Type': 'application/json',
            ...options.headers,
        }),
    })
        .then(async (resp) => {
            dispatch(setBusy({ busy: false }))
            const res = await resp.json()
            if (resp.ok) {
                return res
            } else if (res && res?.message) {
                dispatch(
                    setToastMessage({
                        message: res.message,
                        type: 'error',
                    })
                )
            }
            throw res
        })
        .finally(() => dispatch(setBusy({ busy: false })))
}
